import { ShoppingCart, X, Loader2, Download } from "lucide-react";
import LazyMedia from "./lazy_media_component";
import { isDateTag } from "../../utils/utils-file";

const ImageCard = ({ 
  media, 
  isIOS, 
  setSelectedImage, 
  hasUploadAuth, 
  deletingImages, 
  setDeletingImages, 
  setImages, 
  inCart, 
  removeFromCart, 
  addToCart, 
  photoPrice,
  UPLOAD_WORKER_URL 
}) => {
  const handleDelete = async (e) => {
    e.stopPropagation();
    const authToken = localStorage.getItem("uploadAuth");
    let authGuid = "";

    try {
      if (authToken) {
        const tokenData = JSON.parse(authToken);
        authGuid = tokenData.guid;
      }
    } catch (err) {
      console.error("Failed to parse auth token:", err);
    }

    console.log("Delete button clicked - auth guid:", authGuid);
    const confirmed = window.confirm("Are you sure you want to delete this image?");
    if (!confirmed) return;

    try {
      setDeletingImages((prev) => ({ ...prev, [media.key]: true }));
      console.log("Attempting to delete image:", media.name);
      await fetch(`${UPLOAD_WORKER_URL}/delete/${encodeURIComponent(media.name)}`, {
        method: "DELETE",
        headers: { "X-Auth-Guid": authGuid },
      });
      setImages((prev) => prev.filter((i) => i.key !== media.key));
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete image");
    } finally {
      setDeletingImages((prev) => {
        const newState = { ...prev };
        delete newState[media.key];
        return newState;
      });
    }
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    
    // Create download link
    const link = document.createElement('a');
    link.href = media.url;
    link.download = media.name || 'download';
    link.style.display = 'none';
    
    // Append to body and trigger download
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
    }, 100);
  };

  const isDateTagged = isDateTag(media.metadata?.camera);

  return (
    <div
      key={media.key}
      className="image-card"
      onClick={isIOS ? undefined : () => setSelectedImage(media)}
      onContextMenu={(e) => e.preventDefault()}
      style={{ WebkitTouchCallout: "none", userSelect: "none" }}
    >
      <div className="image-container">
        <LazyMedia media={media} />
        {hasUploadAuth && (
          <button className="delete-image-btn" onClick={handleDelete}>
            {deletingImages[media.key] ? (
              <Loader2 className="animate-spin" size={20} />
            ) : (
              <X size={20} />
            )}
          </button>
        )}
      </div>

      {isDateTagged ? (
        <button
          className="download-btn"
          onClick={handleDownload}
        >
          <Download size={20} /> Download
        </button>
      ) : inCart(media.key) ? (
        <button
          className="remove-from-cart-btn"
          onClick={(e) => {
            e.stopPropagation();
            removeFromCart(media.key);
          }}
        >
          <X size={20} /> Remove from Cart
        </button>
      ) : (
        <button
          className="add-to-cart-btn"
          onClick={(e) => {
            e.stopPropagation();
            addToCart(media);
          }}
        >
          <ShoppingCart size={20} /> Add to Cart –{" "}
          {photoPrice === 0 ? "Free" : `$${photoPrice}`}
        </button>
      )}
    </div>
  );
};

export default ImageCard;
